import { InputFactory } from 'factories/InputFactory';
import { useFormikContext } from 'formik';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { NsKey } from 'enums/NsKey';
import { FC, useCallback } from 'react';
import {
  BorrowerGuaranteeFieldNames,
  BorrowerGuaranteeFormValues,
  BorrowerGuaranteeFormValuesKeys,
  borrowerGuaranteeInputsConfig
} from '../config/BorrowerGuaranteeFormConfig';

interface GuaranteeOptionsCardProps {
  isITTActive: boolean;
  isIPTActive: boolean;
}

export const GuaranteeOptionsCard: FC<GuaranteeOptionsCardProps> = ({
  isITTActive,
  isIPTActive
}) => {
  const { t } = useDynamicTranslation([NsKey.Borrower, NsKey.Pricing]);
  const { values } = useFormikContext<BorrowerGuaranteeFormValues>();

  const renderField = useCallback((fieldName: BorrowerGuaranteeFormValuesKeys) => (
    <InputFactory<BorrowerGuaranteeFormValuesKeys>
      config={borrowerGuaranteeInputsConfig}
      fieldName={fieldName}
      state={values}
    />
  ), [values]);

  return (
    <div className="flex gap-4">
      {/* Quota et Franchise */}
      <div className={`flex flex-col gap-4 p-4 px-8 items-center justify-center rounded-xl bg-white border transition-all duration-300 ease-out ${isITTActive ? 'w-64' : 'grow'}`}>
        <div className="flex items-center">
          <div className="flex flex-col w-full">
            <div className="flex items-center gap-1">
              <p className="text-sm">{t('BORROWER_LOAN_FORM.LABELS.QUOTA')}</p>
            </div>
            <p className="text-xs font-light">en %</p>
          </div>
          <div className="ml-2">
            {renderField(BorrowerGuaranteeFieldNames.Quota)}
          </div>
        </div>

        {isITTActive && (
          <div className="flex items-center animate-fade-in">
            <div className="flex flex-col w-full">
              <div className="flex items-center gap-1">
                <p className="text-sm">{t('PRICING.LABELS.DEDUCTIBLE')}</p>
              </div>
              <p className="text-xs font-light">en jours</p>
            </div>
            <div className="ml-2">
              {renderField(BorrowerGuaranteeFieldNames.Deductible)}
            </div>
          </div>
        )}
      </div>

      {/* Options ITT/IPT */}
      {isITTActive && (
        <div className="flex justify-between p-4 rounded-xl bg-white border grow animate-slide-in-right">
          <div className="col-span-2 flex flex-col justify-evenly gap-4">
            <div>{renderField(BorrowerGuaranteeFieldNames.ContribExempt)}</div>
            <div>{renderField(BorrowerGuaranteeFieldNames.PsyBuyback)}</div>
            {isIPTActive && (
              <div className="animate-fade-in">
                {renderField(BorrowerGuaranteeFieldNames.IsCapital)}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
